module.exports = __webpack_public_path__ + "static/media/solo-scritta-colored.3a19acc2.svg";